<template>
  <eg-b-container>
    <section>
      <breadcrumbs :items="breadcrumbs" />
      <eg-b-row>
        <eg-b-col lg="8">
          <h1>{{ $t("common.editAssignment") }}</h1>
        </eg-b-col>
        <eg-b-col class="text-right create-rubric-column" lg="4" md="12">
          <eg-b-button
            v-if="assignment"
            class="mr-2"
            variant="info"
            :to="`/assignment/${assignment.id}`"
            >{{ $t("common.viewEssays") }}</eg-b-button
          >
        </eg-b-col>
      </eg-b-row>
      <assignment-form v-if="assignment" :assignment="assignment" />
    </section>
  </eg-b-container>
</template>

<script>
import getBreadcrumbs from "./breadcrumbs";
import { getAssignment } from "@/api";
import Breadcrumbs from "@/components/global/breadcrumbs.vue";
import AssignmentForm from "@/components/assignment/assignment_form.vue";

export default {
  name: "EditAssignmentView",

  components: {
    Breadcrumbs,
    AssignmentForm,
  },

  data() {
    return {
      assignment: null,
    };
  },

  computed: {
    breadcrumbs() {
      return getBreadcrumbs("Edit assignment", this.assignment);
    },
  },

  created() {
    this.fetchAssignment();
  },

  methods: {
    async fetchAssignment() {
      this.loading = true;

      try {
        const { data } = await getAssignment(this.$route.params.id);

        this.assignment = data;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.showError(error.response?.data?.error);
      }
    },
  },
};
</script>
